// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071905/js/" + chunkId + "." + {"44":"9b4c0736","225":"2516f38c","481":"816474e7","486":"bed246ba","770":"c1f10d59"}[chunkId] + ".0.9263222809312383.chunk.js";
};